module.exports = {"save":{"labels":{"title":"SAVE","save":"Save","saveBackToList":"and back to list","saveBackToAdd":"and add another","preparePreview":"Prepare previews","warning":"The page is not saved, keep it open","preview":"Preview links"}}}


//////////////////
// WEBPACK FOOTER
// ./components/Custom/Save/admin-en.json
// module id = 184t
// module chunks = 18